import React from "react";
import BookDetails from "./BookDetails";
import NavBar from "./NavBar";
import { useLocation } from "react-router";
import Sidebar from "./Sidebar";

const BookList = () => {
  const location = useLocation();
  const users = location.state || [];
  console.log(users);

  return (
    <div>
      <div>
        {/* <NavBar users={users} /> */}
        {/* <Sidebar /> */}
      </div>
      <div >
        <div>
          <BookDetails roles={users?.roles} />
        </div>
      </div>
    </div>
  );
};

export default BookList;
